import {
  Dispatch,
  useState
} from 'react';
import {
  SupportPlanTaskController,
} from '../../../../api/support/support-plan-task.controller';
import {SupportPlanController} from '../../../../api/support/support-plan.controller';
import {SupportSlotsController} from '../../../../api/support/support-slots.controller';
import {useAsyncEffect} from '../../../../hook/use-initial-load';
import {SupportSlotDefinitionCustomerAssignmentModel} from '../../../../model/support/slot/support-slot-definition-customer-assignment.model';
import {SupportCustomerPlanModel} from '../../../../model/support/support-customer-plan.model';
import {Searchable} from '../../../../state/searchable-state';

export namespace SupportPlanPageHooks {
  import SupportPlanTaskPaginated = SupportPlanTaskController.SupportPlanTaskPaginated;
  export const useCustomerSupportPlan = (organizationId: string): [SupportCustomerPlanModel | null, Dispatch<SupportCustomerPlanModel | null>] => {
    const [supportPlan, setSupportPlan] = useState<SupportCustomerPlanModel | null>(null);
    useAsyncEffect(async () => {
      setSupportPlan(await fetchCustomerSupportPlan(organizationId))
    }, []);
    return [supportPlan, setSupportPlan];
  }


  export const fetchCustomerSupportPlan = async (organizationId: string): Promise<SupportCustomerPlanModel> =>
    (await SupportPlanController.fetchCustomerSupportPlan(organizationId))

  export const useCustomerSlotDefinitions = (organizationId: string): [SupportSlotDefinitionCustomerAssignmentModel[], Dispatch<SupportSlotDefinitionCustomerAssignmentModel[]>] => {
    const [customerSlotDefinitions, setCustomerSlotDefinitions] = useState<SupportSlotDefinitionCustomerAssignmentModel[]>([]);
    useAsyncEffect(async () => {
      setCustomerSlotDefinitions(await fetchCustomerSlotDefinitions(organizationId))
    }, []);
    return [customerSlotDefinitions, setCustomerSlotDefinitions];
  }

  export const fetchCustomerSlotDefinitions = async (organizationId: string): Promise<SupportSlotDefinitionCustomerAssignmentModel[]> =>
    (await SupportSlotsController.fetchCustomerSlotDefinitions(organizationId)).data

  export const useCustomerSupportPlanTasks = (organizationId: string, supportPlanId: string | null, searchable: Searchable): [SupportPlanTaskPaginated | null, Dispatch<SupportPlanTaskPaginated | null>] => {
    const [customerSupportPlanTasks, setCustomerSupportPlanTasks] = useState<SupportPlanTaskPaginated | null>(null);
    useAsyncEffect(async () => {
      if(supportPlanId !== null) {
        setCustomerSupportPlanTasks(await fetchCustomerSupportPlanTasks(organizationId, supportPlanId, searchable))
      }
    }, [supportPlanId, searchable.filters, searchable.groupedFilters, searchable.fullTextSearch, searchable.page, searchable.pageSize, searchable.ordering]);
    return [customerSupportPlanTasks, setCustomerSupportPlanTasks];
  }

  export const fetchCustomerSupportPlanTasks = async (organizationId: string, supportPlanId: string, searchable: Searchable): Promise<SupportPlanTaskPaginated> =>
    (await SupportPlanTaskController.fetchCustomerSupportPlanTasks(organizationId, supportPlanId, searchable))
}